import { Navigate } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';

// Insurance-billing orgs land on Payers; cash orgs land on the catalog
// (the only operational tab they have).
export function BillingSettingsIndexRedirect() {
  const { user } = useUser();
  const settings = user?.organization?.settings || {};
  const isInsuranceOrg = settings.uses_veradigm_billing === true
    || ['insurance_only', 'hybrid'].includes(settings.billing_mode);
  return <Navigate to={isInsuranceOrg ? 'payers' : 'catalog'} replace />;
}
